<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{
        editar ? "Editar registro" : "Nuevo Grupo de modificadores"
      }}</span>
    </v-card-title>
    <v-card-text>
      <v-alert v-model="mostrar_alert" dismissible :type="type_alert">
        <template v-html="html_alert" />
      </v-alert>
      <v-container grid-list-md>
        <v-layout row>
          <v-flex xs12 sm6>
            <v-flex xs12>
              <v-text-field
                :value="form.nombre"
                :error-messages="error_input.nombre"
                label="Nombre"
                @input="(payload) => (form.nombre = payload)"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :value="form.orden"
                :error-messages="error_input.orden"
                label="Orden"
                @input="(payload) => (form.orden = payload)"
              />
            </v-flex>
            <v-flex xs12>
              <v-switch
                v-model="form.requerido"
                :input-value="form.requerido"
                hint="Se debe seleccionar al menos una opción"
                label="Requerido"
                persistent-hint
              />
            </v-flex>
          </v-flex>
          <v-flex xs12 sm4>
            <v-flex xs12>
              <v-text-field
                :value="form.maximo"
                :error-messages="error_input.maximo"
                hint="Límite de cantidad"
                label="Máximo"
                @input="(payload) => (form.maximo = payload)"
              />
            </v-flex>
            <v-flex xs12>
              <v-switch
                v-model="form.multiple"
                :input-value="form.multiple"
                hint="Permitir seleccionar más de una opción"
                label="Multiple"
                persistent-hint
              />
            </v-flex>
            <v-flex xs12>
              <v-switch
                v-model="form.es_extra"
                :input-value="form.es_extra"
                persistent-hint
                hint="Afecta al precio del producto"
                label="Es Extra"
              />
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-col cols="12" v-if="0 !== form.id">
        <v-card elevation="0">
          <v-card-text>
            <v-card-title>
              Modificadores <v-spacer></v-spacer>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="blue"
                    v-on="on"
                    @click="dialogFormDetalles = true"
                  >
                    <v-icon color="white">mdi-plus</v-icon></v-btn
                  >
                </template>
                <span>Agregar modificador</span>
              </v-tooltip>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="form.detalles"
              v-model="form.detalles"
              @item-selected="toggleDetalles"
              elevation="0"
              dense
            >
              <template v-slot:item.actions="{ item }">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      v-on="on"
                      color="light-blue darken-4"
                      @click="editItemId(item.id)"
                    >
                      <v-icon small color="light-blue darken-4"> edit </v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Modificador</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      v-on="on"
                      color="red"
                      @click="deleteItemConfirm(item)"
                    >
                      <v-icon small color="red"> delete </v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar modificador</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="close"> Cancelar </v-btn>
      <v-btn
        color="blue darken-1"
        class="white--text"
        :loading="loading"
        :disabled="loading"
        @click="guardar"
      >
        Guardar
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="dialogFormDetalles" max-width="900px" persistent>
      <FormModificadoresDetalles
        v-if="dialogFormDetalles"
        :modificadorId="form.id"
        :item="editItem()"
        @close="dialogFormDetalles = false"
        @save="saveItem"
      />
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="900px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar registro</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="gray darken-1" @click="dialogDelete = false">
            No
          </v-btn>
          <v-btn
            color="red darken-1"
            class="white--text"
            :loading="loadingDelete"
            :disabled="loadingDelete"
            @click="deleteItem()"
          >
            Sí
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from "axios";
import EventBus from "../EventBus";
import FormModificadoresDetalles from "@components/FormModificadorDetalle";
export default {
  name: "FormModificadores",
  components: { FormModificadoresDetalles },
  props: {
    item: {
      type: [Array, Object],
      default: () => {
        return {
          id: 0,
          nombre: "",
          orden: null,
          multiple: true,
          requerido: true,
          maximo: 0,
          es_extra: true,
          detalles: [],
        };
      },
    },
  },
  data() {
    return {
      dialogDelete: false,
      itemDelete: [],
      loadingDelete: false,
      itemSelectId: 0,
      dialogFormDetalles: false,
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Orden", value: "orden" },
        { text: "Precio", value: "precio" },
        { text: "Acciones", value: "actions", align: "right" },
      ],
      form: Object.assign(
        {
          id: 0,
          nombre: "",
          orden: null,
          multiple: true,
          requerido: true,
          maximo: 0,
          es_extra: true,
          detalles: [],
        },
        this.item
      ),
      error_input: {
        nombre: "",
        activo: "",
      },
      loading: false,
      mostrar_alert: false,
      type_alert: "success",
      html_alert: "",
    };
  },
  computed: {
    editar() {
      return this.item.id > 0;
    },
  },
  methods: {
    saveItem(detalles) {
      this.form.detalles = detalles;
      this.dialogFormDetalles = false;
    },
    toggleDetalles() {},
    close() {
      this.form.id = 0;
      this.form.nombre = "";
      this.$emit("close", true);
    },
    editItem() {
      if (this.itemSelectId) {
        return this.form.detalles.find((item) => item.id === this.itemSelectId);
      } else {
        return {
          id: 0,
          nombre: "",
          activo: true,
        };
      }
    },
    editItemId(itemId) {
      this.itemSelectId = parseInt(itemId);
      this.dialogFormDetalles = true;
    },
    deleteItem() {
      this.loadingDelete = true;
      axios
        .post("/api/modificador_detalle/eliminar/" + this.itemDelete.id)
        .then((response) => {
          this.loadingDelete = false;
          let { data } = response;
          if (data.success) {
            this.snackbar_config.color = "success";
            this.snackbar_config.text_content = data.message;
            this.snackbar = true;
            this.itemDelete = null;
            this.dialogDelete = false;
            this.form.detalles.splice(
              this.form.detalles.indexOf(this.itemDelete),
              1
            );
          }
        })
        .catch((error) => {
          this.loadingDelete = false;
          this.snackbar_config.color = "error";
          if (error.response && error.response.data) {
            this.snackbar_config.text_content = error.response.data.message;
            this.snackbar = true;
          } else {
            this.snackbar_config.text_content = "Error durante la petición";
            this.snackbar = true;
          }
        });
    },
    deleteItemConfirm(item) {
      this.itemDelete = item;
      this.dialogDelete = true;
    },
    guardar() {
      let url_target = this.editar
        ? "/api/modificador/actualizar/" + this.item.id
        : "/api/modificador/guardar";
      this.loading = true;
      this.error_input.nombre = "";
      axios
        .post(url_target, this.form)
        .then((success) => {
          let { data } = success;
          this.loading = false;

          if (data.success) {
            this.form.nombre = "";
            this.form.activo = false;
            EventBus.$emit("tugarrafon:show-snackbar", {
              color: "success",
              text_content: data.message,
            });
            this.$emit("save", data.message);
          }
        })
        .catch((error) => {
          this.loading = false;

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx

            if (error.response.status === 422) {
              this.error_input = Object.assign({}, error.response.data.data);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
          } else {
            // Something happened in setting up the request that triggered an Error
          }
        });
    },
  },
};
</script>

<style>
</style>